<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { AttributesSectionEditorViewModel } from '@Alternatives/Attributes/Components/AttributesSectionEditor'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: AttributesSectionEditorViewModel
    }>()

    const emit = defineEmits<{
        (e: 'update-section-name', newName: string | null, oldName: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const name = computed<string | null>({
        get: () => vm.value.newName,
        set: val => { vm.value.newName = val }
    })

    // ---------------- methods ----------------

    function update()
    {
        emit('update-section-name', name.value, vm.value.oldName)
    }

    function close()
    {
        vm.value.close()
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update section name</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Name:</label>
                            <input v-model.trim="name" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="update" type="button" class="btn btn-primary">Update</button>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>